import React from 'react'
import { useFetchAllShopTags } from '@@partner:graphql/query/shopTag/allShopTags.gql'
import { useGridHelper } from '@@partner:helpers/crud/grid'
import GraphQLCommonErrorDisplay from '@components/common/GraphQLCommonErrorDisplay'
import { generatePath, NavLink, useParams } from 'react-router-dom'
import ShopTopMenu from '@components/shop/ShopTopMenu'
import { FlexboxGrid, Nav, Navbar, Pagination, SelectPicker } from 'rsuite'
import ShopTagsTable from '@components/shopTag/table/ShopTagsTable'
import { ROUTE_SHOP_TAGS_CREATE } from '@@partner:config/routes'
import { AddOutline } from 'react-ionicons'



export default function ShopTagsPage () {
  const { brandSlug } = useParams<any>()

  const {
    page,
    limit,
    defaultLimitOptions,
    tableSort,
    handlePageSelect,
    handleLimitSelect,
    handleSortColumn
  } = useGridHelper()

  const { data, loading, error } = useFetchAllShopTags({
    pager: {
      page,
      limit
    },
    sort: {
      fieldName: tableSort.fieldName,
      direction: tableSort.direction
    }
  })


  const shopTags = data?.allShopTags?.edges ?? []
  const pageInfo = data?.allShopTags?.pageInfo


  if (error) {
    return (
      <GraphQLCommonErrorDisplay
        title="Ошибка загрузки сервисов в магазине"
        error={error}
      />
    )
  }

  return (
    <div className="ShopsPage">
      <h1 className="u-heading">Сервисы в магазине</h1>
      <ShopTopMenu />
      <Navbar appearance='subtle'>
        <Nav>
          <Nav.Item
            icon={<AddOutline />}
            as={NavLink}
            to={generatePath(ROUTE_SHOP_TAGS_CREATE, {
              brandSlug
            })}
          >
              Добавить тег
          </Nav.Item>
        </Nav>
      </Navbar>

      <ShopTagsTable
        loading={loading}
        shopTags={shopTags}
        brandSlug={brandSlug}
        onSortColumn={handleSortColumn}
        tableSort={tableSort}
      />

      <FlexboxGrid
        justify="space-between"
        align="middle"
        style={{ marginTop: 10 }}
      >
        <Pagination
          last
          first
          next
          prev
          ellipsis
          activePage={page}
          pages={pageInfo?.lastPage}
          total={pageInfo?.total ?? 0}
          maxButtons={10}
          onSelect={handlePageSelect}
        />
        <SelectPicker
          value={limit}
          data={defaultLimitOptions.map((key) => ({ value: key, label: key }))}
          cleanable={false}
          searchable={false}
          onChange={handleLimitSelect}
        />
      </FlexboxGrid>
    </div>
  )

}